import {
    downloadTransactionStatementAPI,
    downloadTransactionStatementCsvAPI,
} from './index';


export class ReportsService {
    public downloadTransactionStatement(rawQueryParams: {
    accountId: number;
    dateFrom: string;
    dateTo: string;
  }): Promise<Blob> {
        const { accountId, dateFrom, dateTo } = rawQueryParams;
        return downloadTransactionStatementAPI({ params: { accountId, dateFrom, dateTo } });
    }

    public downloadTransactionStatementCsv(rawQueryParams: {
    accountId: number;
    dateFrom: string;
    dateTo: string;
  }): Promise<Blob> {
        const { accountId, dateFrom, dateTo } = rawQueryParams;
        return downloadTransactionStatementCsvAPI({
            params: {
                account_id: accountId,
                start_date: dateFrom,
                end_date: dateTo,
                format: 'CSV',
            },
        });
    }
}

export default ReportsService;
